export const Breakpoint = Object.freeze({
  XS: 0,
  SM: 768,
  MD: 1024,
  LG: 1920,
  XL: 2300,
});